<template>
  <div id="course-create-details-tab" @keyup.ctrl.enter="simulation_update_data">
    <div class="vx-col w-full">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-1/3 w-full mb-2 ">
          <vs-input v-model="dataLocal.name" class="w-full" label-placeholder="Simulation Name"/>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2 ">
          <vs-select class="w-full mt-5" placeholder="Simulation Status" v-model="dataLocal.status">
            <vs-select-item :key="index" :value="option" :text="option.charAt(0).toUpperCase() + option.slice(1)" v-for="(option,index) in status_options"/>
          </vs-select>
        </div>
        <div class="vx-col sm:w-1/3 w-full mb-2 ">
          <vs-select class="w-full mt-5" placeholder="Simulation Difficulty" v-model="dataLocal.difficulty.id">
            <vs-select-item :key="index.id" :value="option.id" :text="option.label" v-for="(option,index) in difficulties"/>
          </vs-select>
        </div>
      </div>
     <!--- <div class="vx-row  mb-4">
        <div class="vx-col w-full  ">
          <vs-input v-model="dataLocal.demonstration_video_id" class="w-full"
                    label-placeholder="Demonstration Video ID"/>
        </div>
      </div> --->

      <div class="vx-row  mb-4">
        <div class="vx-col w-full">
          <vs-input v-model="dataLocal.thumbnail" class="w-full" label-placeholder="Thumbnail URL"/>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full ">
          <vs-textarea v-model="dataLocal.description" :counter-danger.sync="simulation_description_counter"
                       counter="400" height="100px"
                       label="Simulation Description"/>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">

          <vs-button class="mb-2 mr-2" color="success" type="filled"
                     @click="simulation_update_data ">Update Simulation
          </vs-button>
          <vs-button class="mb-2 ml-2" color="warning" type="border"
                     @click="reset_data">Reset
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      simulation_description_counter: null,

      status_options: [
        'active',
        'hidden',
        'disabled'
      ],

      difficulties: [
        {id: '0', label: 'Simple'},
        {id: '1', label: 'Easy'},
        {id: '2', label: 'Moderate'},
        {id: '3', label: 'Hard'},
        {id: '4', label: 'Challenging'}
      ]

    }
  },
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    simulation_update_data () {
      this.$emit('update_simulation_data', this.dataLocal)
    },
    reset_data () {
      this.dataLocal = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>

<style scoped>

</style>
